import { Card, Divider, Grid, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import VerifyCarnetIDController from "./controllers/VerifyCarnetIdController";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import { useState, useEffect } from "react";

function VerifyCarnetID() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Verificar si el usuario está autenticado
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);

  // Vista simplificada sin autenticación
  const SimpleView = () => (
    <MDBox
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
      }}
    >
      <Card sx={{ maxWidth: 600, width: "100%" }}>
        <MDBox
          mx={2}
          mt={2}
          py={2}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
        >
          <MDTypography variant="h4" color="white" textAlign="center">
            Verificación de Carnet
          </MDTypography>
        </MDBox>
        <MDBox>
          <VerifyCarnetIDController isAuthenticated={false} />
        </MDBox>
      </Card>
    </MDBox>
  );

  // Vista completa con autenticación
  const AuthenticatedView = () => (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h3" color="white">
                  Verificar carnet
                </MDTypography>
              </MDBox>
              <MDBox>
                <VerifyCarnetIDController isAuthenticated={true} />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );

  // Renderizar según el estado de autenticación
  return isAuthenticated ? <AuthenticatedView /> : <SimpleView />;
}

export default VerifyCarnetID;
